export const DEFAULT_EMPTY_TERM = 'No items to show!'
export const DEFAULT_EMPTY_TERM_SEARCH = 'Start typing to see results'
